import React, { ReactElement } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import { getIconAsset } from './Icon.assets';
import { ICON_COLOR } from './Icon.colors';
import { ICON_TYPE } from './Icon.types';
import { ICON_SIZE } from './ICON_SIZE';
import { iconStyles, IIconSizeStyles } from './IconStyles';

export * from './Icon.types';
export * from './Icon.colors';

function computeSizeClass (type: ICON_TYPE, size: ICON_SIZE = ICON_SIZE.SMALL): string {
    const iconSizeStyles: IIconSizeStyles | undefined = iconStyles[type];

    if (!iconSizeStyles) {
        return '';
    }

    return iconSizeStyles[size] || '';
}

export type IIconProps = IQATestableProps & IStyleableProps & {
    type: ICON_TYPE;
    size?: ICON_SIZE;
    color?: ICON_COLOR;
    alt?: string;
};

export function OzIcon (props: IIconProps): ReactElement {
    const {
        size,
        className = '',
        'data-testid': dataTest,
        color = ICON_COLOR.DARK,
        type,
        alt = '',
    }: IIconProps = props;

    const sizeClass: string = computeSizeClass(type, size);
    const iconAsset: string = getIconAsset(type, color);

    return (
        <img
            className={`${sizeClass} ${className}`}
            data-testid={dataTest}
            src={iconAsset}
            alt={alt}
        />
    );
}
